module.exports = "<md-icon ng-if=\"!vm.useSvgIcon\" class=\"material-icons\">{{vm.id}}</md-icon>\n<md-icon ng-if=\"vm.useSvgIcon\" class=\"material-icons\" md-svg-icon=\"{{vm.id}}\"></md-icon>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase/components/shareBaseIcon/shareBaseIcon.template.html
// module id = 1122
// module chunks = 0